// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7972":"css/admin-app.6859","9432":"css/app.6859"}[chunkId] + ".css";
};